import AbstractRequestTask from '../../AbstractRequestTask';
import Launcher from '../../../apa/Launcher';
import { ENABLE_MODAL_RETRIES } from '../../../RequestManagerConstants';
import Utils from 'src/utils/Utils';
import { isEnabledCenterNotificationsWithByUserType } from 'src/utils/Utils';

class LoginOttV2Task extends AbstractRequestTask {
    constructor(params = {}, body={}, forceMwfkUrl = null) {
        super();
        this.queryParams = params;
        this.body = body;
        this.forceMwfkUrl = forceMwfkUrl;
        this.statusCode404As200 = true

        this.statusCode403As200 = true;
        this.statusCode500As200 = true;

        this.isByUserType = isEnabledCenterNotificationsWithByUserType();
        this.version = this.isByUserType ? "v3" : "v2";
    }

    getMethod() {
        return 'POST';
    }

    getUrl() {
        const url = this.forceMwfkUrl ? this.forceMwfkUrl : Launcher.get('akamai_mfwk');
        return `${url}/services/user/${this.version}/ott/login?${this.getQueryStringParams()}`;
    }

    getParams() {
        return Utils.encodeParams(this.body);
      }

    getHeaders() {
        return {
            'Content-Type': 'application/x-www-form-urlencoded',
        };
    }

    getQueryStringParams() {
        const params = super.getParams();
        delete params.HKS;
        delete params.api_version;
        delete params.user_token;
        delete params.username;
        delete this.queryParams.includpaywayprofile;
        return Utils.buildQueryParams({...params, ...this.queryParams});
    }

    getShowErrorModal() {
        return ENABLE_MODAL_RETRIES;
    }

    isValid(response) {
        if (response && 
            response.errors && 
            response.errors[0] && 
            response.errors[0].code && 
            response.errors[0].code !== 'USR_REG_00004') return false;
        return true;
        
    }

    getStatusCode403As200(){
    return this.statusCode403As200;
    }

    getStatusCode500As200(){
    return this.statusCode500As200;
    }
}

export default LoginOttV2Task;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/v2/LoginOttv2Task.js